import { render, staticRenderFns } from "./contactListsForm.vue?vue&type=template&id=6a10fb00&scoped=true&"
import script from "./contactListsForm.vue?vue&type=script&lang=js&"
export * from "./contactListsForm.vue?vue&type=script&lang=js&"
import style0 from "./contactListsForm.vue?vue&type=style&index=0&id=6a10fb00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a10fb00",
  null
  
)

export default component.exports